import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_Order } from "./SIV_Order";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_DeliveryNotesAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  date?: Date | undefined;
  deliveryAddresses?: any[] | undefined;
  deliveryAttributes?: string | undefined;
  deliveryDate?: Date | undefined;
  directory?: string | undefined;
  directoryDate?: Date | undefined;
  facility?: string | undefined;
  licensePlate?: string | undefined;
  lotNo?: string | undefined;
  no: string;
  notFoundValues: any;
  order: SIV_Order;
  remarks?: any[] | undefined;
  tenant?: OD3_Tenant | undefined;
  transportedBy?: string | undefined;
  transportType?: string | undefined;
  xcellizeNo?: string | undefined;
}

export class SIV_DeliveryNotes extends Parse.Object<SIV_DeliveryNotesAttributes> {
  static className: string = "SIV_DeliveryNotes";

  constructor(data?: Partial<SIV_DeliveryNotesAttributes>) {
    super("SIV_DeliveryNotes", data as SIV_DeliveryNotesAttributes);
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get date(): Date | undefined {
    return super.get("date");
  }
  set date(value: Date | undefined) {
    super.set("date", value);
  }

  get deliveryAddresses(): any[] | undefined {
    return super.get("deliveryAddresses");
  }
  set deliveryAddresses(value: any[] | undefined) {
    super.set("deliveryAddresses", value);
  }

  get deliveryAttributes(): string | undefined {
    return super.get("deliveryAttributes");
  }
  set deliveryAttributes(value: string | undefined) {
    super.set("deliveryAttributes", value);
  }

  get deliveryDate(): Date | undefined {
    return super.get("deliveryDate");
  }
  set deliveryDate(value: Date | undefined) {
    super.set("deliveryDate", value);
  }

  get directory(): string | undefined {
    return super.get("directory");
  }
  set directory(value: string | undefined) {
    super.set("directory", value);
  }

  get directoryDate(): Date | undefined {
    return super.get("directoryDate");
  }
  set directoryDate(value: Date | undefined) {
    super.set("directoryDate", value);
  }

  get facility(): string | undefined {
    return super.get("facility");
  }
  set facility(value: string | undefined) {
    super.set("facility", value);
  }

  get licensePlate(): string | undefined {
    return super.get("licensePlate");
  }
  set licensePlate(value: string | undefined) {
    super.set("licensePlate", value);
  }

  get lotNo(): string | undefined {
    return super.get("lotNo");
  }
  set lotNo(value: string | undefined) {
    super.set("lotNo", value);
  }

  get no(): string {
    return super.get("no");
  }
  set no(value: string) {
    super.set("no", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get order(): SIV_Order {
    return super.get("order");
  }
  set order(value: SIV_Order) {
    super.set("order", value);
  }

  get remarks(): any[] | undefined {
    return super.get("remarks");
  }
  set remarks(value: any[] | undefined) {
    super.set("remarks", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }

  get transportedBy(): string | undefined {
    return super.get("transportedBy");
  }
  set transportedBy(value: string | undefined) {
    super.set("transportedBy", value);
  }

  get transportType(): string | undefined {
    return super.get("transportType");
  }
  set transportType(value: string | undefined) {
    super.set("transportType", value);
  }

  get xcellizeNo(): string | undefined {
    return super.get("xcellizeNo");
  }
  set xcellizeNo(value: string | undefined) {
    super.set("xcellizeNo", value);
  }
}

Parse.Object.registerSubclass("SIV_DeliveryNotes", SIV_DeliveryNotes);
